(ns app.front.review-v2.applicant
  (:require [app.domain.attachment.model :as attachment-model]
            [app.domain.review.model :as review-model]
            [app.front.process :as process]
            [app.front.review-v2.subs :as review-subs]
            [app.front.review-v2.view :as review-view]
            [app.front.ui.actions :as ui-actions]
            [app.front.ui.error-list :as ui-error-list]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.split :as ui-split]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag]]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.upload :as att-upload]
            [app.front.view.conversations.core :as conversations]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]))



(def centered
  :div.mt-4.flex.justify-around)

(defmulti acceptance-parent-col (fn [_ entity] (:entity/type entity)))

(defmethod acceptance-parent-col :default
  [{:keys [tr]} acceptance-parent]
  [:div
   [:span.font-bold.mr-2 (tr [(:entity/type acceptance-parent)])]])

(defmethod acceptance-parent-col :entity.type/form
  [{:keys [tr]} form]
  [:div
   [:span.font-bold.mr-2 (tr [:review/form-title]) ":"]
   (-> form :form/schema :form.schema/name)])

(def loading-col-value
  [:div.inline-block.w-24 (cc/skeleton-text {:class-name "mb-0"})])

(defmethod acceptance-parent-col :entity.type/attachment-version
  [{:keys [tr lang]} attachment-version]
  [:div
   [:span.font-bold.mr-2 (tr [:review/attachment-title]) ":"]
   (if (<sub [::ws-subs/loading-config?])
     loading-col-value
     (->> attachment-version
          :attachment/_versions
          (attachment-model/attachment-title lang)))])

(defn attachment-request-col
  [{:keys [tr]} attachment-request]
  [:div
   [:span.font-bold.mr-2 (tr [:review/requested-attachment]) ":"]
   (:requirement/title attachment-request)])

(defn party-role-request-col
  [{:keys [tr]} party-role-request]
  [:div
   [:span.font-bold.mr-2 (tr [:review/requested-party-role]) ":"]
   (if (<sub [::ws-subs/loading-config?])
     loading-col-value
     (:requirement/title party-role-request))])

(defmulti acceptance-expand-ext (fn [_ acceptance]
                                  (-> acceptance :entity/parent :entity/type)))

(defmethod acceptance-expand-ext :default
  [_ _]
  nil)

(defmethod acceptance-expand-ext :entity.type/form
  [_ _]
  nil)

(defn attachment-version [{:keys [tr attachment-id attachment-version title]}]
  (let [file (attachment-model/latest-file-version-of-attachment-version attachment-version)]
    [:div.mb-2
     [:span.font-bold.mr-2 title ":"]
     (cc/link
       {:href (attachment-common/attachment-version-link
                attachment-id
                (:db/id file)
                true)}
       (:attachment.version.file/filename file))
     [:div (tr [:attachments/version-number]
               [(:attachment.version/version attachment-version)])]]))

(defmethod acceptance-expand-ext :entity.type/attachment-version
  [{:keys [tr]} acceptance]
  (let [reviewed-version           (-> acceptance :entity/parent)
        {attachment-id :db/id
         :as           attachment} (:attachment/_versions reviewed-version)
        latest-version             (-> attachment attachment-model/latest-attachment-version)]
    [:<>
     [attachment-version (util/mmap {:attachment-version reviewed-version
                                     :title              (tr [:review/attachment-reviewed-version])}
                                    tr attachment-id)]
     (when-not (= latest-version reviewed-version)
       [attachment-version (util/mmap {:attachment-version latest-version
                                       :title              (tr [(if (:attachment.version/authority-markup? latest-version)
                                                                  :review/attachment-markup-version
                                                                  :review/attachment-latest-version)])}
                                      tr attachment-id)])
     [:div.mt-2
      [att-upload/upload-version-button
       (util/mmap {:parent-id (-> attachment :entity/parent :db/id)
                   :kind      :primary
                   :size      :small}
                  attachment-id)]]]))

(defn- reviewer-display [{:keys [tr sub-review]} creator]
  [:div
   [:span.font-bold.mr-2 (tr [:review/reviewer]) ":"]
   (user-model/full-name creator)
   (cc/link
     {:on-click   #(>evt [::conversations/open-overlay-for-direct-msg (:db/id creator) sub-review])
      :class-name "cursor-pointer ml-2 inline-flex"}
     (tr [:review/direct-message])
     (cc/icon {:icon        i/conversation
               :description ""
               :class-name  "ml-1"}))])

(defn acceptance-expand [{:keys [tr] :as opts}
                         {:entity/keys     [creator]
                          :acceptance/keys [text]
                          :as              acceptance}]
  [:div.ml-4.m-2.py-2
   (when text
     [:div.bg-ui-light-gray.p-2.rounded.my-2.px-4
      [ui-rt/editor-legacy
       {:initial-value text}]])
   [reviewer-display (util/mmap tr) creator]
   [:div.border-solid.border-t-2.border-ui-gray.pt-4.mt-2
    [acceptance-expand-ext opts acceptance]]])

(defmulti make-href (fn [acceptance] (-> acceptance :entity/parent :entity/type)))

(defmethod make-href :default [_] nil)

(defmethod make-href :entity.type/form [acceptance]
  (href/href :view/form
             {:workspace-id (-> acceptance
                                :entity/parent
                                :entity/parent
                                :entity/parent
                                :workspace/id)
              :form-id      (-> acceptance
                                :entity/parent
                                :db/id)}))

(defmethod make-href :entity.type/attachment-version [acceptance]
  (href/href :view/application-attachments
             {:workspace-id (-> acceptance
                                :entity/parent
                                :attachment/_versions
                                :entity/parent
                                :entity/parent
                                :workspace/id)}
             {:id (-> acceptance
                      :entity/parent
                      :attachment/_versions
                      :db/id)}))

(defn get-acceptance-status-color [acceptance]
  (case (:acceptance/customer-value acceptance)
    :acceptance.customer-value/updated-by-customer
    :task
    :acceptance.customer-value/waiting-for-customer
    :critical
    nil))

(defn changes-table [{:keys [tr lang acceptances att-requests party-requests]}]
  (let [opts (util/mmap tr lang)]
    [:div.pb-1
     [ui-table/modern-responsive-table
      {:cols          [[nil (fn [acceptance]
                              [acceptance-parent-col
                               opts
                               (:entity/parent acceptance)])]]
       :expanded-func (fn [acceptance]
                        [acceptance-expand opts acceptance])
       :id-func       (comp :db/id :entity/parent)
       :headerless?   true
       :tr            tr
       :link          {:make-href   make-href
                       :description (tr [:review/go-to])}
       :get-status    get-acceptance-status-color
       :items         acceptances}]

     [ui-table/modern-responsive-table
      {:items       att-requests
       :get-status  #(get review-view/request-status-indicator (-> % :requirement/border-color keyword) :task)
       :cols        [[nil (fn [request]
                            [attachment-request-col
                             opts
                             request])]]
       :tr          tr
       :headerless? true}]
     [ui-table/modern-responsive-table
      {:items       party-requests
       :get-status  #(get review-view/request-status-indicator (-> % :requirement/border-color keyword) :task)
       :cols        [[nil (fn [request]
                            [party-role-request-col
                             opts
                             request])]]
       :tr          tr
       :headerless? true}]]))

(defn review-result [{:keys [sub-review comment tr created phase-id review]}]
  (let [signal   [:process.signal/mark-review-changes-done
                  {:review-id (:db/id review)}]
        problems (<sub [::process/signal-errors-for-error-list phase-id signal])]
    [:div
     (when comment
       [:div.border.border-ui-gray.border-solid.px-2.pt-2.mb-4.rounded.mt-2
        [ui-rt/editor-legacy
         {:initial-value comment}]])
     [:div
      [:span.font-bold.mr-2 (tr [:review/date]) ":"]
      ((<sub [::date-util/date-time-fn]) created)]
     [reviewer-display (util/mmap tr sub-review) (:sub-review/reviewer sub-review)]
     (when problems
       [centered
        [ui-error-list/signal-error-list tr problems]])
     [centered
      (if (<sub [::ws-subs/loading-config?])
        (cc/button-skeleton {:small true})
        [ui-actions/signal-button
         (util/mmap {:target-entity phase-id
                     :button-opts   {:icon i/check
                                     :size :small}}
                    tr signal)])]]))

(defn applicant-review-progress [{:keys [tr phase-id]}]
  (let [lang (<sub [:language])]
    [:section
     (for-frag [[review
                 {:entity/keys     [created]
                  :sub-review/keys [comment]
                  :as              sub-review}
                 acceptances] (<sub [::review-subs/sub-review+acceptances phase-id])]
       (let [review-result-title     (tr [:review/review-result])
             review-result-component [review-result (util/mmap sub-review comment tr created phase-id review)]
             att-requests            (<sub [::review-subs/attachment-requirements phase-id (:db/id review)])
             party-requests          (<sub [::review-subs/party-role-requirements phase-id (:db/id review)])]
         (when (review-model/applicant-review-visible? review)
           [:div.mb-4.mt-4
            [:h3
             (if (<sub [::ws-subs/loading-config?])
               [:div.w-2-5 (cc/skeleton-text {:heading true})]
               (review-model/review-name review lang))]
            (if (or (seq acceptances) (seq att-requests) (seq party-requests))
              ;; show acceptances table when applicable
              [ui-split/split-pane {:left-title  review-result-title
                                    :right-title (tr [:review/change-requests])}
               review-result-component
               [changes-table (util/mmap tr lang acceptances att-requests party-requests)]]
              ;; no acceptances, just pending review comments
              [:div
               [ui-split/header-element review-result-title]
               review-result-component])])))]))
